<template>
	<div class="k-page-wrapper">
		<h1 class="k-page-title">
			<k-btn icon large color="primary" class="mr-2" accessible-label="Return to admin main" @click="return_to_admin_main"><k-icon>fas fa-cog</k-icon></k-btn>
			Term Management
		</h1>

		<k-card class="mb-4 pa-4">
			<k-card-text>
				<div class="d-flex align-center">
					<div style="width:220px">
						<k-text-field
							v-model=" local_settings.default_academic_year"
							label="Default Academic Year"
							:mask="year_mask"
							:rules="year_rules"
							dense outlined hide-details
						/>
					</div>

					<k-checkbox
						v-model="local_settings.block_sis_data_for_students"
						class="my-0 ml-4"
						label="Block SIS data for students and parents"
						hide-details
					/>
				</div>

				<div class="terms-manager">
					<h2>Terms</h2>

					<div class="terms d-flex align-center">
						<div v-for="(term_dates, index) in local_settings.term_dates" :key="index" class="mr-10">
							<TermDatePicker v-model="term_dates['start_date']" :label="`Term ${index + 1} Start Date`"/>
							<TermDatePicker v-model="term_dates['end_date']" :label="`Term ${index + 1} End Date`" class="mt-4"/>
						</div>
					</div>
				</div>
				

				<div class="weeks-manager">
					<div class="d-flex">
						<h2>Term Weeks</h2>

						<k-spacer/>

						<k-btn color="secondary" small @click="add_week">
							<k-icon class="mr-2" small>fas fa-plus</k-icon> Add Week
						</k-btn>
					</div>

					<div class="weeks">
						<div v-for="(week, index) in local_settings.term_weeks" :key="'week-' + index" class="week d-flex">
							<TermDatePicker
								v-model="week[0]"
								:label="`Week ${index + 1} Start Date`"
								class="mr-2"
							/>

							<TermDatePicker
								v-model="week[1]"
								:label="`Week ${index + 1} End Date`"
								class="mr-2"
							/>
							
							<k-btn color="secondary" class="mt-1" icon small :accessible-label="`Remove week ${index + 1}`" @click="remove_week(index)">
								<k-icon>fas fa-trash-alt</k-icon>
							</k-btn>
						</div>
					</div>
				</div>
			</k-card-text>

			<k-card-actions class="px-4">
				<k-spacer/>
				<k-btn color="primary" @click="save_settings">Save</k-btn>
			</k-card-actions>
		</k-card>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import TermDatePicker from './TermDatePicker'

export default {
	components: { TermDatePicker },

	data() {
		return {
			local_settings: null,
			year_mask: '####',
			year_rules: [
				value => /^\d{4}$/.test(value) || 'Invalid format. Please enter a valid year.',
				value => {
					const year = parseInt(value);
					return year >= 1900 && year <= new Date().getFullYear() + 10 || 'Invalid year. Please enter a year between 1900 and the current year + 10.';
				}
			]
		}
	},

	computed: {
		...mapState(['term_settings']),

		week_options() {
			return this.local_settings.term_weeks ? this.local_settings.term_weeks.map((x, index) => { return {value: index + 1, text: 'Week ' + (index + 1)}}) : []
		},
	},

	created() {
		this.local_settings = object_copy(this.term_settings)
	},

	methods: {
		return_to_admin_main() {
			this.$router.push({ path: '/welcome' })
		},

		save_settings() {
			vapp.$store.dispatch('admin_update_term_settings', this. local_settings)
				.then(() => {
					this.$store.commit('set', ['term_settings', this. local_settings])
					this.$alert('Settings updated.')
				})
		},

		add_week() {
			this.$prompt({
				title: 'Add Week',
				text: '<div class="mb-1">Select the week after which you would like to add a new week.</div>',
				promptType: 'select',
				selectOptions: this.week_options,
				acceptText: 'Select',
			}).then(index => {
				this. local_settings.term_weeks.splice(index, 0, [null, null])

				this.$nextTick(() => {
					let weeks = document.querySelectorAll(".week")
					weeks[index].scrollIntoView()
				})
			}).catch(n => {console.error(n)})
		},

		remove_week(index) {
			this. local_settings.term_weeks.splice(index, 1)
		}
	},
}
</script>

<style lang="scss" scoped>
.terms-manager {
	margin-top: 16px;

	.terms {
		margin-top: 16px;
	}
}

.weeks-manager {
	margin-top: 20px;

	.weeks {
		height: 300px;
		overflow: scroll;
		border: 1px solid #cdcdcd;
		border-radius: 4px;
		margin-top: 16px;

		.week {
			margin: 16px;
		}
	}
}
</style>
